const PARTICLE_CLASS = 'wc-confetti-particle';
const COLOR_VARIANT_COUNT = 5;
const PARTICLE_COUNT = 16;
const PARTICLE_LIFETIME_MS = 1300;

interface UseConfettiReturn {
  triggerConfetti: (anchorEl?: HTMLElement | null) => void;
}

const useConfetti = (): UseConfettiReturn => {
  const triggerConfetti = (anchorEl?: HTMLElement | null): void => {
    if (!anchorEl) {
      return;
    }
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const rect = anchorEl.getBoundingClientRect();

    for (let i = 0; i < PARTICLE_COUNT; i += 1) {
      const particle = document.createElement('span');
      particle.classList.add(
        PARTICLE_CLASS,
        `${PARTICLE_CLASS}--color-${(i % COLOR_VARIANT_COUNT) + 1}`,
      );
      particle.style.left = `${rect.left + rect.width / 2}px`;
      particle.style.top = `${rect.top}px`;
      particle.style.setProperty('--wc-confetti-dx', `${(Math.random() - 0.5) * 180}px`);
      particle.style.setProperty('--wc-confetti-dy', `${-(60 + Math.random() * 120)}px`);
      particle.style.setProperty('--wc-confetti-rotation', `${Math.random() * 360}deg`);
      particle.style.animationDuration = `${800 + Math.random() * 400}ms`;
      document.body.appendChild(particle);

      setTimeout(() => particle.remove(), PARTICLE_LIFETIME_MS);
    }
  };

  return { triggerConfetti };
};

export default useConfetti;
